// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InfoLabel_wrapper__rKWBB","text":"InfoLabel_text__FO_Vm","icon":"InfoLabel_icon__97bir"};